import AttributeSafeUsersRepository from 'repositories/admin/AttributeSafeUsersRepository';
import { buildFilterParams } from 'utils/FilterParamsBuilder';

export function searchUser(filters) {
  const params = buildFilterParams(filters);

  return () => AttributeSafeUsersRepository.index({ ...params, per: 100 }).then(({ items }) => items);
}
